// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"169915cb","370":"999ffac6","488":"b0dae9ac","548":"098e9cc5","711":"2b2a9c8b","880":"56254a13"}[chunkId] + ".chunk.js";
};